import { parse, stringify } from 'zipson'
import CryptoJS from 'crypto-js'

const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY

export interface AuthState {
  tokens: {
    UM_OAUTH_CD: string
    ACCESS_TOKEN: string
    JADOO_TOKEN: string
    REFRESH_TOKEN: string
  }
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    tokens: {
      UM_OAUTH_CD: '',
      ACCESS_TOKEN: '',
      JADOO_TOKEN: '',
      REFRESH_TOKEN: '',
    },
  }),
  actions: {
    setTokens(tokens: {
      UM_OAUTH_CD: string
      ACCESS_TOKEN: string
      JADOO_TOKEN: string
      REFRESH_TOKEN: string
    }) {
      this.tokens = tokens
    },

    clearTokens() {
      this.tokens = {
        UM_OAUTH_CD: '',
        ACCESS_TOKEN: '',
        JADOO_TOKEN: '',
        REFRESH_TOKEN: '',
      }
    },
  },
  persist: {
    key: 'auth',
    storage: persistedState.localStorage,
    serializer: {
      deserialize: (value: string) => {
        try {
          const bytes = CryptoJS.AES.decrypt(value, ENCRYPTION_KEY)
          const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
          return parse(decryptedData)
        } catch (error) {
          console.error('인증 스토어 복호화 중 오류 발생:', error)
          return null
        }
      },
      serialize: (value: any) => {
        const serializedData = stringify(value)
        return CryptoJS.AES.encrypt(serializedData, ENCRYPTION_KEY).toString()
      },
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
